import CTA from "./CTA";
import HeaderSocials from "./HeaderSocials";
import ME from "../../assets/me.jpg";
import "./Header.css";

export default function Header() {
  return (
    <header id="top" className="header">
      <div className="container header__container">
        <div className="header__stack">
          <div className="header__intro">
            <p className="header__greeting">Hello, my name is</p>
            <h1 className="header__name">Trai Torti</h1>
            <p className="header__role">
              Backend software engineer &amp; pipeline TD
            </p>
            <p className="header__stack-line text-light">
              Python · Django · AWS · PostgreSQL
            </p>
            <p className="header__availability text-light">
              Gold Coast, QLD · backend, platform &amp; VFX pipeline roles
            </p>
            <CTA />
          </div>

          <div className="header__visual">
            <div className="me">
              <img src={ME} alt="Trai Torti" />
            </div>
          </div>

          <a href="#work" className="header__scroll">
            Scroll to work
          </a>
        </div>

        <HeaderSocials />
      </div>
    </header>
  );
}
